import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Subscription } from 'rxjs';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { Idle } from '@ng-idle/core';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import { ControlType } from '../../../common/components/filter/filter-enum';
import { FilterOption } from '../../../common/components/filter/filter-model';
import { FilterComponent } from '../../../common/components/filter/filter.component';
import { MasterConstants } from '../../../common/constants/master-constants';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { CommonService } from '../../../services/common/common.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { SliderModelService } from '../../../services/infrastructure/sliderModel.service';
import { GrowerProgramService } from '../../../services/seed/growerProgram.service';
import { SeedReplantService } from '../../../services/seed/seed-replant/seed-replant.service';
import { GrowerProgramImportComponent } from '../grower-program-import/grower-program-import.component';
import { GrowerProgramsData, LineError } from './grower-program-dashboard-data';

@Component({
  selector: 'app-grower-program-dashboard',
  templateUrl: './grower-program-dashboard.component.html',
  styleUrls: ['./grower-program-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GrowerProgramDashboardComponent implements OnInit, OnDestroy {

  //ViewChild
  @ViewChild(FilterComponent) private _filter: FilterComponent;

  //Number Variables
  growerAccountNo: number = 0;
  sellerAccountNo: number = 0;
  selectedCount = 0;
  checkBoxCount: number;
  currentErrorRow = 1;
  index = 0;
  currentIndex = null;
  prevCropYear: any;
  isCropYearChange: boolean = false;
  //Grid Datasource
  growerProgramData: MatTableDataSource<GrowerProgramsData>;

  //Any variables
  nextErrorId: any;
  headerCompany: any;
  headerYear: any;
  defaultYear: any;
  autoCancelCounter: any;
  masterData: any;
  budgetTypeList: any;
  currentElement: any;

  //String Variables
  budgetFieldName: string = 'budgetId';
  voidReason: null;
  retailerFieldName: string = 'retailerAccountNumber';
  programFieldName: string = 'programMasterId';
  salesChannelFieldName: string = 'productSegmentId';
  tabNode: string;
  loggedUserId: string = null;
  submitErrorMsg = "One (or more) of the selected spends are already submitted and waiting for approval. " +
    "Please validate the spend status and select the spends that are not submitted.";
  notAuthorizedErrorMsg = "Error: You are not authorized to approve/reject the spend.";
  resetFilterMsg = "All filters have been reset due to the change in the crop year. Please reapply your filters to continue.";
  errorFlagList: any[] = [
    { id: 'ALL', value: 'ALL' },
    { id: 'BU', value: 'BU' },
    { id: 'L1', value: 'L1' },
    { id: 'L2', value: 'L2' },
    { id: 'L3', value: 'L3' },
  ];


  //Boolean variables
  isSaveClicked: boolean;
  isSearchClicked: boolean;
  editToolKit: boolean;
  showTabs: boolean;
  showSubmit: boolean;
  showVoid: boolean;
  showApproveReject: boolean;
  showDelete: boolean;
  isAllAccountsChecked: boolean;
  isBudgetExists: boolean = true;
  isGridDataDirty: boolean = false;
  isFirstTimeload: boolean = true;
  isReadOnlyAccess: any = true;
  isMasterDataLoaded: boolean = false;
  disableSaveButton = true;
  hasChangeAdded = false;
  showErrorBlock = false;
  isAutosave = false;
  timedOut = false;
  showTimer = false;
  reportingSubscriptionStatus: boolean = false;
  hasSpendBudget: boolean = false;
  hasPendingSpendForApproval: boolean = false;
  hasAlBuFlagData: boolean = false;
  showOnlyActiveLines: boolean = true;
  //Array variables
  subscription = new Array<Subscription>();
  errorMsgs = new Array();
  lineErrors = { itemId: 0, errors: [] };
  originalProductItemsDataSource: MatTableDataSource<GrowerProgramsData>;
  dashboardFilter: DashboardFilter;
  filterOptionsData: Array<FilterOption>;
  programList: any[] = [];
  validProgramList: any[] = [];
  budgetList: any[] = [];
  validBudgetList: any[] = [];
  retailerList: any[] = [];
  growerMainList: any[] = [];
  sellerMainList: any[] = [];
  spendRetailerList: any[] = [];
  sales: any[] = [];
  marketingList: any[] = [];
  productLineList: any[] = [];
  retailerCombinedList: any[] = [];
  growerCombinedList: any[] = [];
  budgetCombinedList: any[] = [];
  programCombinedList: any[] = [];
  sellerCombinedList: any[] = [];
  landingData: any[] = [];
  gridFullData: any[] = [];
  inCompleteSpends: any[] = [];
  filter: any = {};
  exportNullFilter: any = {};
  spendIds: number[];
  dirtySpendIds: any[] = [];
  statusList: any[] = [];
  cropYearList: any[] = [];
  manualOrderExtractionEnable: boolean = false;
  manualOrderExtractionEnablecb: boolean = false;
  programTypeList: any[] = [{ id: "Retailer", value: "Retailer" }, { id: "Grower", value: "Grower" }];
  displayedColumns: string[] = [
    'checkbox',
    'budgetName',
    'programType',
    'retailerName',
    'initialBudget',
    'remainingBudget',
    'estimatedQuantity',
    'estimatedSpend',
    'parent',
    'grower',
    'seller',
    'budgetUser',
    'programName',
    'salesChannel',
    'marketingBrand',
    'productLine',
    'cyOrder',
    'status',
    'responsible',
    'approvedPayment',
    'customerCreditedAmount',
    'updateTimestamp',
    'comment'
  ];

  validExtractStatusSet = new Set([
    "Ready to extract Error - ItemCode".toLowerCase(),
    "Ready to extract Error - ItemPrice".toLowerCase()
  ]);

  private isValidExtractStatus(status: string | null | undefined): boolean {
    return this.validExtractStatusSet.has((status || '').trim().toLowerCase());
  }

  constructor(private growerProgramService: GrowerProgramService,
    private loaderService: LoaderService,
    private sliderModelService: SliderModelService,
    private toastrService: ToastrService,
    private seedReplantService: SeedReplantService,
    private localStorageService: LocalStorageService,
    private matDialog: MatDialog,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private commonService: CommonService,
    private idle: Idle) {

    this.dashboardFilter = new DashboardFilter();
    this.isGridDataDirty = false;
  }

  ngOnInit(): void {
    this.getLocalStorage();
    this.setDefaultFilter();
    this.setCropYearFilter(this.defaultYear);
    this.setFilterAndGridColumn(false, this.defaultYear);
    this.getMasterAndLandingData(true);
    this.bindSellerAndGrowerDialogSelectedValue();
    this.bindSelectedBudget();
    this.bindSelectedProgram();
  }

  setCropYearFilter(cropyear: any) {
    this.filter.cropYearList = cropyear;
  }

  getLocalStorage() {
    //if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
    //  this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    //}

    if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
      this.headerCompany = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
    }

    if (this.headerCompany) {
      const evloveAccess = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evloveAccess) {
        var userMenuAccessList = evloveAccess.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        this.cropYearList = evloveAccess.resultData.find(x => x.userIdCompanyCode == this.headerCompany).gpCropYearList;
        // Default to the latest active GP crop year, not the Evolve seed (header) crop year.
        if (this.cropYearList && this.cropYearList.length > 0) {
          this.headerYear = Math.max(...this.cropYearList.map(x => Number(x.id)));
        } else {
          // No GP crop years available -> no default crop year should be selected.
          this.headerYear = null;
        }
        this.prevCropYear = this.headerYear;
        this.defaultYear = this.headerYear;
        this.isReadOnlyAccess = this.commonService.checkUserRoleAccessType(
          MasterConstants.FUNCTION_CODE.GROWER_PROGRAMS, MasterConstants.USER_ACCESS.READ_ONLY, userMenuAccessList);
        this.loggedUserId = evloveAccess.resultData[0].userId

      }
    }
  }


  //Get Master, Landing and Auto Save Configuration Values using Fork Join
  getMasterAndLandingData(isFirstLoad: boolean, isClearFilter: boolean = false) {
    this.loaderService.setLoaderStatus(true);
    if (isClearFilter) {
      this.setDefaultFilter();
      this._filter.clearAllFilterWithoutEmit();
      this.setCropYearFilter(this.defaultYear);
    }
    this.loaderService.setLoaderStatus(true);
    const forkJoinApIs = [];
    forkJoinApIs.push(this.growerProgramService.getGrowerProgramMasterData());
    forkJoinApIs.push(this.growerProgramService.getGrowerProgramLandingData({ ...this.filter, ShowActiveLines: false }));
    this.subscription.push(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      if (result.length > 0) {
        this.masterData = result[0];
        this.reportingSubscriptionStatus = this.masterData.isSubscribed != null ? this.masterData.isSubscribed : false;
        this.gridFullData = Object.assign([], result[1]);
        this.setHasAlBuFlagData(result[1]);
        result[1] = (result[1] ?? []).filter(x => !x.voided);
        this.landingData = result[1];
        this.setMasterData(result[0]);
        this.bindGridData(result[1], true);
        this.hasSpendBudget = result[1].length > 0;
        // set autosave configuration
        if (this.localStorageService.get(MasterConstants.GP_AUTO_SAVE_CONFIGURATION)) {
          let autoSaveConfiguration = JSON.parse(this.localStorageService.get(MasterConstants.GP_AUTO_SAVE_CONFIGURATION));
          if (autoSaveConfiguration != null && autoSaveConfiguration != undefined) {
            this.idle.setIdle(autoSaveConfiguration.idleTime);
            this.idle.setTimeout(autoSaveConfiguration.autoSaveTime);
            fromEvent(document, 'mousemove').subscribe(() => this.resetIdleAndTimeOut());
            fromEvent(document, 'touchstart').subscribe(() => this.resetIdleAndTimeOut());
            fromEvent(document, 'keydown').subscribe(() => this.resetIdleAndTimeOut());
            this.AddIdleAutoCancelEvents();
          }
        }
        if (isFirstLoad && !this.isReadOnlyAccess) {
          this.onAddProduct();
        }
        this.isMasterDataLoaded = true;
        this.filterOptionsData = [];
        this.setFilterAndGridColumn(true, this.defaultYear);
        this.setDropDownValues();
        if (this.isMasterDataLoaded && !isClearFilter)
          this.loaderService.setLoaderStatus(false);
      }
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get Landing Data
  getLandingData(isSearch: boolean, isReset: boolean, isNeedToBindGrid: boolean, isDeleted: boolean, isSetDrpDwn: boolean) {
    const cropyear = this.filter.cropYearList == '' ? null : this.filter.cropYearList;
    this.isAllAccountsChecked = false;
    this.checkBoxCount = 0;
    this.selectedCount = 0;
    this.tabNode = '';
    this.showTabs = false;
    this.tabNode = '';
    this.voidReason = null;
    this.manualOrderExtractionEnablecb = null;
    if (this.isCropYearChange && isReset == false) {
      this.toastrService.warning(this.resetFilterMsg);
      this._filter.clearAllFilterWithoutEmit();
      this.setDefaultFilter();
      this.setCropYearFilter(cropyear);
    }
    this.subscription.push(this.growerProgramService.getGrowerProgramLandingData({ ...this.filter, ShowActiveLines: this.showOnlyActiveLines }).subscribe(result => {
      this.landingData = result;
      if (this.isCropYearChange || isReset || isSetDrpDwn) {
        this.setHasAlBuFlagData(result);
      }
      this.hasSpendBudget = result.length > 0;
      this.dirtySpendIds = [];
      if (isNeedToBindGrid) {
        this.bindGridData(result);
      }
      if (this.isCropYearChange) {
        this.filterOptionsData = [];
        let IsSetCropYearfilter = cropyear == null ? false : true;
        this.setFilterAndGridColumn(IsSetCropYearfilter, cropyear);
      }
      if (isSearch == false && isNeedToBindGrid == true) {
        this.setDropDownValues();
        this.onAddProduct();
      }

      if (isSetDrpDwn == true) {
        this.setDropDownValues();
      }
      if (isReset) {
        this.toastrService.success('Reset successfully.');
      }

      if (isDeleted) {
        this.handleDeletion();
      }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get the list of Growers
  getGrowerListByAccount(shiptoaccount: number, growernumber: string) {
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.companyCode = this.headerCompany;
    this.dashboardFilter.shipToAccount = shiptoaccount;
    const growerFilters = { 'GMK': growernumber };
    this.subscription.push(this.seedReplantService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      const gmkToCheck = result[0].gmk;
      const gmkAlreadyExists = this.growerMainList.some(item => item.accountNumber === gmkToCheck && item.retailerNumber === shiptoaccount);
      if (!gmkAlreadyExists) {
        const growerObject = {
          accountNumber: gmkToCheck,
          accountName: (result[0].businessName == null || result[0].businessName == '' ?
            (result[0].firstName != null && result[0].firstName != '' ? result[0].firstName : '') +
            (result[0].middleName != null && result[0].middleName != '' ? ' ' + result[0].middleName : '') +
            (result[0].lastName != null && result[0].lastName != '' ? ' ' + result[0].lastName : '')
            : result[0].businessName),
          accountCity: result[0].city,
          accountState: result[0].state,
          accountAddress1: result[0].address1,
          accountAddress2: result[0].address2,
          accountZipCode: result[0].zip,
          retailerNumber: shiptoaccount,
          isActive: true
        };
        this.growerMainList.push(growerObject);
      }
      this.bindGridData(this.growerProgramData.data);
      if (this.currentIndex > -1) {
        this.growerProgramData.data[this.currentIndex].growerNumber = gmkToCheck ? gmkToCheck : null;
        this.growerProgramData.data[this.currentIndex].isGrowerActive = true;
        this.dirtySpendIds.push(this.growerProgramData.data[this.currentIndex].spendID);
      }

    }, error => { LolLoggerService.error(error); }));
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      cropYearList: null,
      programNameList: null,
      budgetNameList: null,
      retailerNameList: null,
      growerList: null,
      sellerList: null,
      productLineList: null,
      marketingBrandList: null,
      salesChannelList: null,
      statusList: null,
      programTypeList: null,
      budgetUserList: null,
      flagList: null
    };
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn(setdefaultvalue: boolean, cropYear: any) {
    setdefaultvalue = setdefaultvalue && cropYear != '';
    this.filterOptionsData = [
      { label: 'Crop Year', key: 'cropYearList', isMultiSelect: false, controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', filterValue: setdefaultvalue ? cropYear?.toString() : null, controlData: setdefaultvalue ? this.cropYearList : [] },
      { label: 'Program Name', key: 'programNameList', controlType: ControlType.ValuesWithIDDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Budget Name', key: 'budgetNameList', controlType: ControlType.ValuesWithIDDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Retailer', key: 'retailerNameList', controlType: ControlType.AccountDropDown, controlDataBindLabel: 'accountName', controlDataBindValue: 'accountNumber', chipLabel: 'accountNumber', isMultiSelect: true },
      { label: 'Grower', key: 'growerList', controlType: ControlType.DropDown, controlDataBindLabel: 'accountName', controlDataBindValue: 'accountNumber' },
      { label: 'Seller', key: 'sellerList', controlType: ControlType.DropDown, controlDataBindLabel: 'accountName', controlDataBindValue: 'accountNumber' },
      { label: 'SDM', key: 'budgetUserList', controlType: ControlType.ValuesWithIDDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Product Line', key: 'productLineList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Marketing Brand', key: 'marketingBrandList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Sales Channel', key: 'salesChannelList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Status', key: 'statusList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      { label: 'Program Type', key: 'programTypeList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
      ...(this.hasAlBuFlagData ? [
        { label: 'Error Flags', key: 'flagList', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', controlData: this.errorFlagList }
      ] : [])
    ];
  }

  // Set the master data into respective variables
  setMasterData(masterData) {
    this.programList = masterData.programMasterList;
    this.validProgramList = this.programList.filter(x => x.isValid === true);
    this.budgetList = masterData.programBudgetList;
    this.validBudgetList = this.budgetList.filter(x => x.isValid === true);
    this.retailerList = masterData.retailerList;
    this.growerMainList = masterData.growerList.filter(x => x.accountName != null && x.accountName != '');
    this.sellerMainList = masterData.sellerList;
    this.sales = masterData.salesChannelList;
    this.marketingList = masterData.marketingBrandList;
    this.productLineList = masterData.productLineMasterList;
    this.statusList = masterData.statusFilter;
    this.programCombinedList = Object.assign([], this.programList);
    this.budgetCombinedList = Object.assign([], this.budgetList);
    this.retailerCombinedList = Object.assign([], this.retailerList);
    this.growerCombinedList = Object.assign([], this.growerMainList);
    this.sellerCombinedList = Object.assign([], this.sellerMainList);
    this.isBudgetExists = this.budgetList.length > 0 ? true : false;
    this.manualOrderExtractionEnable = masterData.manualOrderExtractionEnable;
  }

  getRetailersForBudget(budgetId: any, sourceRetailers: any[] = this.retailerList, selectedRetailerAccountNumber: number = null) {
    if (!budgetId) {
      return sourceRetailers;
    }

    const selectedBudget = this.budgetList.find(x => x.id == budgetId);
    const allowedRetailers = selectedBudget?.allowedRetailerAccountNumbers;

    if (!Array.isArray(allowedRetailers)) {
      return sourceRetailers;
    }

    const filteredRetailers = sourceRetailers.filter(x => allowedRetailers.includes(x.accountNumber));

    if (selectedRetailerAccountNumber && !filteredRetailers.some(x => x.accountNumber == selectedRetailerAccountNumber)) {
      const selectedRetailer = sourceRetailers.find(x => x.accountNumber == selectedRetailerAccountNumber);
      if (selectedRetailer) {
        filteredRetailers.push(selectedRetailer);
      }
    }

    return filteredRetailers;
  }

  getValidRetailersForShowAll(element: any) {
    if (element?.budgetID) {
      return this.getRetailersForBudget(element.budgetID, this.retailerList);
    }

    const validRetailerAccounts = new Set<number>();
    this.validBudgetList.forEach(budget => {
      if (Array.isArray(budget.allowedRetailerAccountNumbers)) {
        budget.allowedRetailerAccountNumbers.forEach(accountNo => validRetailerAccounts.add(accountNo));
      }
    });

    return this.retailerList.filter(x => validRetailerAccounts.has(x.accountNumber));
  }

  setHasAlBuFlagData(landingData: any[]) {
    this.hasAlBuFlagData = (landingData ?? []).some(x => (x?.hasAlBuFlagData ?? x?.HasAlBuFlagData) === true);
  }

  // Set Drop down values for filter
  setDropDownValues() {
    this.filterOptionsData.find(x => x.key === 'cropYearList').controlData = this.cropYearList;
    this.filterOptionsData.find(x => x.key === 'productLineList').controlData = this.productLineList;
    this.filterOptionsData.find(x => x.key === 'marketingBrandList').controlData = this.marketingList;
    this.filterOptionsData.find(x => x.key === 'salesChannelList').controlData = this.sales;
    this.filterOptionsData.find(x => x.key === 'statusList').controlData = this.statusList;
    this.filterOptionsData.find(x => x.key === 'programTypeList').controlData = this.programTypeList;
    const uniqueAccountNumbers = new Set();

    // Filter the data and add unique account numbers to the set
    this.filterOptionsData.find((x) => x.key === 'sellerList').controlData = this.sellerCombinedList.filter((o) => {
      const isUnique = !uniqueAccountNumbers.has(o.accountNumber);
      if (isUnique) {
        uniqueAccountNumbers.add(o.accountNumber);
      }
      return isUnique && this.gridFullData.some(({ sellerAccountNumber }) => o.accountNumber === sellerAccountNumber);
    });

    const uniqueGrowerNumbers = new Set();

    //Filter the data and add unique Seller numbers to the set
    this.filterOptionsData.find((x) => x.key === 'growerList').controlData = this.growerCombinedList.filter((o) => {
      const isUnique = !uniqueGrowerNumbers.has(o.accountNumber);
      if (isUnique) {
        uniqueGrowerNumbers.add(o.accountNumber);
      }
      return isUnique && this.gridFullData.some(({ growerNumber }) => o.accountNumber === growerNumber);
    });

    // For Program Name List DropDown
    let programNameFilter = this.programCombinedList.filter(o => this.gridFullData.some(({ programMasterID }) => o.id === programMasterID));
    const programNames: any[] = [];
    for (var i = 0; i < programNameFilter.length; i++) {
      programNames.push({
        id: programNameFilter[i].id,
        value: programNameFilter[i].value + " (" + programNameFilter[i].id + ")",
        cropYear: programNameFilter[i].cropYear,
        isDisable: programNameFilter[i].isDisable
      });
    }
    this.filterOptionsData.find(x => x.key === 'programNameList').controlData = programNames;

    // For Budget List DropDown
    const budgetNames: any[] = [];
    let budgetDrpDown = this.budgetCombinedList.filter(o => this.gridFullData.some(({ budgetID }) => o.id === budgetID));
    for (var i = 0; i < budgetDrpDown.length; i++) {
      budgetNames.push({
        id: budgetDrpDown[i].id,
        value: budgetDrpDown[i].value + " (" + budgetDrpDown[i].id + ")",
        isDisable: budgetDrpDown[i].isDisable
      });
    }
    this.filterOptionsData.find(x => x.key === 'budgetNameList').controlData = budgetNames;

    const retailerNames: any[] = [];
    for (var i = 0; i < this.retailerCombinedList.length; i++) {
      retailerNames.push({
        accountNumber: this.retailerCombinedList[i].accountNumber,
        accountName: this.retailerCombinedList[i].accountName,
        address1: this.retailerCombinedList[i].accountAddress1,
        city: this.retailerCombinedList[i].accountCity,
        state: this.retailerCombinedList[i].accountState,
        zipCode: this.retailerCombinedList[i].accountZipCode
      });
    }
    this.filterOptionsData.find(x => x.key === 'retailerNameList').controlData = retailerNames.filter(o => this.gridFullData.some(({ retailerAccountNumber }) => o.accountNumber === retailerAccountNumber));

    // For Budget List DropDown
    const budgetUserList: any[] = [];
    let budgetUsrDrpDown = Array.from(
      new Set(this.gridFullData.filter(x => x.budgetUser != 0).map(item => `${item.budgetUser}|${item.budgetUserName}`))
    ).map(item => {
      const [budgetUser, name] = item.split('|');
      return { budgetUser, name };
    });


    //Array.from(new Set(this.gridFullData.map(item => item.budgetUser))); 
    for (var i = 0; i < budgetUsrDrpDown.length; i++) {
      budgetUserList.push({
        id: budgetUsrDrpDown[i].budgetUser,
        value: budgetUsrDrpDown[i].name + " (" + budgetUsrDrpDown[i].budgetUser + ")"
      });
    }
    this.filterOptionsData.find(x => x.key === 'budgetUserList').controlData = budgetUserList;

  }

  // Bind the Grid 
  bindGridData(gridData: any[], isUpdateMasterData: boolean = false) {
    this.hasPendingSpendForApproval = gridData.filter(x => x.hasApprovalAccess == true).length > 0;
    var filterData = gridData.filter(x => x.spendID != 0);
    var firstRow = filterData.length > 1 ? filterData[0] : gridData[0];

    gridData.forEach(data => {
      let retailerLocalList = Object.assign([], this.retailerList);
      let sellerLocalList = Object.assign([], this.sellerMainList);
      let growerLocalList = Object.assign([], this.growerMainList);
      let programLocalList = Object.assign([], this.programList);
      let budgetLocalList = Object.assign([], this.budgetList);
      if (this.isAutosave && gridData[0] && gridData[0].spendRetailerList === undefined) {
        gridData[0].spendRetailerList = this.spendRetailerList;
      }

      if (firstRow && firstRow.spendRetailerList) {
        this.spendRetailerList = firstRow.spendRetailerList;
        let missingRetailer = firstRow.spendRetailerList.find(x => x.accountNumber == data.retailerAccountNumber);
        if (missingRetailer != null && missingRetailer != undefined) {
          retailerLocalList.push(missingRetailer);
        }
      }

      if (firstRow && firstRow.spendGrowerList) {
        firstRow.spendGrowerList.forEach(gr => {
          growerLocalList.push(gr);
        });
      }

      if (firstRow && firstRow.spendSellerList) {
        firstRow.spendSellerList.forEach(sl => {
          sellerLocalList.push(sl);
        });
      }

      if (firstRow && firstRow.expiredSpendGrowerList) {
        firstRow.expiredSpendGrowerList.forEach(gr => {
          if (data.growerNumber === gr.accountNumber) {
            growerLocalList.push(gr);
          }

        });
      }

      if (firstRow && firstRow.expiredSpendSellerList) {
        firstRow.expiredSpendSellerList.forEach(sl => {
          if (data.sellerAccountNumber === sl.accountNumber) {
            sellerLocalList.push(sl);
          }

        });
      }

      if (firstRow && firstRow.approverProgram) {
        firstRow.approverProgram.forEach(pr => {
          if (data.programMasterID === pr.id) {
            programLocalList.push(pr);
          }

        });
      }

      if (firstRow && firstRow.approverBudget) {
        firstRow.approverBudget.forEach(bd => {
          if (data.budgetID === bd.id) {
            budgetLocalList.push(bd);
          }

        });
      }

      if (data.isApproverSpend || data.isAlBuFlagAdd) {
        data.budgetFilteredList = budgetLocalList;
      } else if (data.spendID === 0) {
        data.budgetFilteredList = data.programMasterID ? this.validBudgetList.filter(x => x.programMasterId == data.programMasterID) : this.validBudgetList;
      } else {
        data.budgetFilteredList = data.programMasterID ? this.budgetList.filter(x => x.programMasterId == data.programMasterID) : this.budgetList;
      }

      data.programFilteredList = programLocalList;
      if (data.spendID === 0) {
        data.programFilteredList = this.validProgramList;
      }
      data.retailerFilteredList = this.getRetailersForBudget(data.budgetID, retailerLocalList, data.retailerAccountNumber);

      data.growerListFiltered = growerLocalList.sort((a, b) => a.isActive - b.isActive).filter(x => x.retailerNumber === data.retailerAccountNumber).filter((item, i, arr) => arr.findIndex((t) => t.accountNumber === item.accountNumber) === i);
      data.sellerListFiltered = sellerLocalList.sort((a, b) => a.isActive - b.isActive).filter(x => x.retailerNumber === data.retailerAccountNumber).filter((item, i, arr) => arr.findIndex((t) => t.accountNumber === item.accountNumber) === i);

      data.growerListCount = data.growerListFiltered.length;
      data.isSellerActive = data.sellerAccountNumber && data.sellerListFiltered.filter(x => x.accountNumber == data.sellerAccountNumber).length > 0 ? data.sellerListFiltered.filter(x => x.isActive == true && x.accountNumber == data.sellerAccountNumber).length > 0 : true;
      data.isGrowerActive = data.growerNumber && data.growerListFiltered.filter(x => x.accountNumber == data.growerNumber).length > 0 ? data.growerListFiltered.filter(x => x.isActive == true && x.accountNumber == data.growerNumber).length > 0 : true;
      data.id = data.spendID;
      data.lineErrors = { itemId: data.id, errors: [] };
      data.parent = retailerLocalList.filter(x => x.accountNumber == data.retailerAccountNumber).length > 0 ?
        retailerLocalList.find(x => x.accountNumber == data.retailerAccountNumber)?.parentName : '';

    });
    if (!isUpdateMasterData) {
      this.gridFullData = Object.assign([], gridData);
    }
    //show warning message for limit records
    const dataCount = gridData.length;
    if (gridData && gridData.length > 0 && dataCount > this.masterData.recordsLimit) {
      gridData.splice(this.masterData.recordsLimit);
      this.landingData = gridData;
      this.toastrService.warning('Results exceed ' + this.masterData.recordsLimit + ' records.');
    }
    this.growerProgramData = new MatTableDataSource(gridData);
    if (gridData && gridData.length > 0) {
      this.toastrService.warning('Total number of records for the applied filters: ' + dataCount);
    }
    else {
      this.toastrService.warning('Total number of records for the applied filters: 0');
    }
    // Adding incomplete spend(including empty) in existing datalist
    if (this.isAutosave && this.inCompleteSpends.length > 0) {
      this.inCompleteSpends.forEach(inCompleteRec => {
        this.growerProgramData.data.unshift(inCompleteRec);
      });
      gridData[0].spendRetailerList = this.spendRetailerList;
    }
    if (firstRow && firstRow.spendRetailerList && firstRow?.spendRetailerList.length > 0) {
      firstRow.spendRetailerList.forEach(x => {
        if (!this.retailerCombinedList.find(y => y.accountNumber === x.accountNumber))
          this.retailerCombinedList.push(x);
      })

    }

    if (firstRow && firstRow.spendGrowerList && firstRow?.spendGrowerList.length > 0) {
      firstRow.spendGrowerList.forEach(x => {
        if (!this.growerCombinedList.find(y => y.accountNumber === x.accountNumber))
          this.growerCombinedList.push(x);
      })

    }

    if (firstRow && firstRow.spendSellerList && firstRow?.spendSellerList.length > 0) {
      firstRow.spendSellerList.forEach(x => {
        if (!this.sellerCombinedList.find(y => y.accountNumber === x.accountNumber))
          this.sellerCombinedList.push(x);
      })
    }

    if (firstRow && firstRow.expiredSpendGrowerList && firstRow?.expiredSpendGrowerList.length > 0) {
      firstRow.expiredSpendGrowerList.forEach(x => {
        if (!this.growerCombinedList.find(y => y.accountNumber === x.accountNumber))
          this.growerCombinedList.push(x);
      })
    }

    if (firstRow && firstRow.expiredSpendSellerList && firstRow?.expiredSpendSellerList.length > 0) {
      firstRow.expiredSpendSellerList.forEach(x => {
        if (!this.sellerCombinedList.find(y => y.accountNumber === x.accountNumber))
          this.sellerCombinedList.push(x);
      })
    }

    if (firstRow && firstRow.approverBudget && firstRow?.approverBudget.length > 0) {
      firstRow.approverBudget.forEach(x => {
        if (!this.budgetCombinedList.find(y => y.id === x.id))
          this.budgetCombinedList.push(x);
      })
    }

    if (firstRow && firstRow.approverProgram && firstRow?.approverProgram.length > 0) {
      firstRow.approverProgram.forEach(x => {
        if (!this.programCombinedList.find(y => y.id === x.id))
          this.programCombinedList.push(x);
      })
    }

  }



  // Bind Seller and grower values from the slider
  bindSellerAndGrowerDialogSelectedValue() {
    this.subscription.push(this.sliderModelService.growerProgramData.subscribe(x => {
      this.disableSaveButton = false;
      this.getGrowerListByAccount(x[0].account, x[0].newGrower);
    }, error => { LolLoggerService.error(error); }));

  }

  // Bind Budget Name from dialog/slider
  bindSelectedBudget() {
    this.subscription.push(this.sliderModelService.selectedBudgetValue.subscribe(x => {
      if (x) {
        this.onGridBudgetChange(x, this.currentElement, this.budgetFieldName, this.currentIndex);
        this.growerProgramData.data[this.currentIndex].budgetID = x.id;
      }
    }, error => { LolLoggerService.error(error); }));
  }

  // Bind Program Name from dialog
  bindSelectedProgram() {
    this.subscription.push(this.sliderModelService.selectedProgramValue.subscribe(x => {
      if (x) {
        this.growerProgramData.data[this.currentIndex].programMasterID = x.id;
        this.onGridProgramChange(x, this.currentElement, this.programFieldName, this.currentIndex);
      }
    }, error => { LolLoggerService.error(error); }));
  }

  // Add new Row into grid
  onAddProduct() {
    if (this.isBudgetExists) {
      const blankData = new GrowerProgramsData();
      /*this.isSubmitEnable = true;*/
      // assigning id based on the data present in last of array
      const prevData =
        this.growerProgramData?.data == undefined
          ? []
          : this.growerProgramData.data;
      blankData.id = prevData.length == 0 ? prevData.length + 1 : prevData.slice(-1)[0].id + 1;
      blankData.programName = '';
      blankData.budgetID = null;
      blankData.budgetName = '';
      blankData.retailerName = null;
      blankData.growerNumber = null;
      blankData.salesChannel = null;
      blankData.marketingBrand = '';
      blankData.productLine = '';
      blankData.estimatedQuantity = 0;
      blankData.estimatedAmountToPay = 0;
      blankData.approvedAmountToPay = 0;
      blankData.customerCreditAmount = 0;
      blankData.retailerAccountNumber = null;
      blankData.programMasterID = null;
      blankData.tag = '';
      blankData.productSegmentId = null;
      blankData.budgetFilteredList = this.validBudgetList.filter(x => x.programActive == true && x.budgetActive == true);
      blankData.retailerFilteredList = this.getRetailersForBudget(blankData.budgetID);
      blankData.programFilteredList = this.validProgramList.filter(x => x.programActive == true);
      blankData.spendID = 0;
      blankData.isExistingRecord = false;
      blankData.cropYear = this.defaultYear;
      blankData.isSellerActive = true;
      blankData.isGrowerActive = true;
      blankData.programType = '';
      blankData.budgetUser = 0;
      blankData.voided = false;
      blankData.voidReason = null;
      blankData.budgetUserName = '';
      blankData.lineErrors = { itemId: blankData.id, errors: [] };
      if (prevData.length > 0) {
        prevData.map((x) => {
          x['toBeValidated'] = false;
          let er = x.lineErrors.errors.length > 0 ? x.lineErrors.errors : [];
          x['lineErrors'] = { itemId: blankData.id, errors: er };
          return x;
        });
      }
      this.growerProgramData = new MatTableDataSource([
        blankData,
        ...prevData,
      ]);
      this.originalProductItemsDataSource = new MatTableDataSource(JSON.parse(JSON.stringify(this.growerProgramData.data)));
    }
  }

  // On Change event of Program Name
  onGridProgramChange($event, element, fieldName, index) {
    if ($event != undefined) {
      element.productSegmentId = $event.productSegmentID;
      element.marketingBrandId = $event.marketingBrandID;
      element.productLineId = $event.productLineID;
      element.programType = $event.retailerProgram;
      const budgetSource = element.spendID === 0 ? this.validBudgetList : this.budgetList;
      element.budgetFilteredList = budgetSource.filter(x => x.programMasterId == $event.id && x.programActive == true && x.budgetActive == true);
      element.budgetID = null;
      element.retailerAccountNumber = null;
      element.retailerFilteredList = this.getRetailersForBudget(element.budgetID);
      element.budgetUserName = '';
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
      this.isGridDataDirty = true;
      const tempData = this.growerProgramData?.data;
      // Update object's name property.
      tempData[index][fieldName] = element[fieldName];

      this.validateSpendDetailsFieldDS(tempData[index], fieldName, 'productSegmentId');
    }
    else {
      element.productSegmentId = null;
      element.marketingBrandId = null;
      element.productLineId = null;
      element.programType = null;
      const budgetSource = element.spendID === 0 ? this.validBudgetList : this.budgetList;
      element.budgetFilteredList = budgetSource.filter(x => x.programActive == true && x.budgetActive == true);
      element.budgetID = null;
      element.retailerAccountNumber = null;
      element.retailerFilteredList = this.getRetailersForBudget(element.budgetID);
      element.budgetUserName = '';
    }

    this.enableDisableSaveButton();
  }

  // On Change event of Budget Name
  onGridBudgetChange($event, element, fieldName, index) {
    if ($event != undefined) {
      element.programMasterID = $event.programMasterId;
      const budgetSource = element.spendID === 0 ? this.validBudgetList : this.budgetList;
      element.budgetFilteredList = budgetSource.filter(x => x.programMasterId == $event.programMasterId && x.programActive == true && x.budgetActive == true);
      const selectedProgram = this.programList.find(
        x => x.id == $event.programMasterId && x.programActive === true
      );

      element.productSegmentId =
        selectedProgram?.productSegmentID?.length > 0
          ? selectedProgram.productSegmentID
          : null;

      element.marketingBrandId = selectedProgram?.marketingBrandID ?? null;
      element.productLineId = selectedProgram?.productLineID ?? null;
      element.programType = selectedProgram?.retailerProgram ?? null;

      element.budgetUserName = $event.budgetOwner;
      element.retailerFilteredList = this.getRetailersForBudget($event.id);

      if (!element.retailerFilteredList.some(x => x.accountNumber == element.retailerAccountNumber)) {
        element.retailerAccountNumber = null;
        element.growerNumber = null;
        element.sellerAccountNumber = null;
        element.growerListFiltered = [];
        element.sellerListFiltered = [];
        element.parent = '';
      }

      const tempData = this.growerProgramData?.data;
      if (!element.marketingBrandId) {
        element.marketingBrandId = null;
      }
      if (!element.productSegmentId) {
        element.productSegmentId = null;
      }
      // Update object's name property.
      tempData[index][fieldName] = element[fieldName];
      this.validateSpendDetailsFieldDS(tempData[index], fieldName, 'programMasterId');
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });

      this.isGridDataDirty = true
    }
    else {
      element.programMasterID = null;
      const budgetSource = element.spendID === 0 ? this.validBudgetList : this.budgetList;
      element.budgetFilteredList = budgetSource.filter(x => x.programActive == true && x.budgetActive == true);
      element.productSegmentId = null;
      element.marketingBrandId = null;
      element.productLineId = null;
      element.programType = null;
      element.retailerFilteredList = this.getRetailersForBudget(element.budgetID);
      element.budgetUserName = '';
    }
    this.enableDisableSaveButton();
  }

  // On Change event of Retailer
  onGridInputChangeRetailer($event, element: any, fieldName, index) {
    if ($event != undefined) {
      element.growerNumber = null;
      element.sellerAccountNumber = null;
      element.growerListFiltered = this.growerMainList.filter(x => x.retailerNumber == $event.accountNumber);
      element.sellerListFiltered = this.sellerMainList.filter(x => x.retailerNumber == $event.accountNumber);
      const selectedRetailer = (element.retailerFilteredList || this.retailerList).find(x => x.accountNumber == $event.accountNumber)
        || this.retailerList.find(x => x.accountNumber == $event.accountNumber);
      element.parent = selectedRetailer ? selectedRetailer.parentName : '';
      element.growerListCount = element.growerListFiltered.length;
      this.growerAccountNo = $event.accountNumber;
      this.sellerAccountNo = $event.accountNumber;
      element.retailerAccountNumber = $event.accountNumber;
      const tempData = this.growerProgramData?.data;
      // Update object's name property.
      tempData[index][fieldName] = element[fieldName];

      this.validateSpendDetailsFieldDS(tempData[index], fieldName);
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
      this.enableDisableSaveButton();

    } else {
      element.growerNumber = null;
      element.sellerAccountNumber = null;
      element.retailerAccountNumber = '';
      element.growerListFiltered = [];
      element.sellerListFiltered = [];
      element.parent = '';
      element.growerListCount = element.growerListFiltered.length;
    }
    this.isGridDataDirty = true;

  }

  // On Change event of Sales Channel
  onGridInputChangeSales($event, element: any, fieldName, index) {
    if ($event != undefined) {
      const tempData = this.growerProgramData?.data;
      // Update object's name property.
      tempData[index][fieldName] = element[fieldName];
      this.growerProgramData = new MatTableDataSource(tempData);

      this.validateSpendDetailsFieldDS(tempData[index], fieldName);
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
      this.enableDisableSaveButton();
    }
    this.isGridDataDirty = true;
    if (element.spendID) {
      this.dirtySpendIds.push(element.spendID);
    }

  }

  //Change event of dropdown values
  onGridInputChange($event, element: any) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
    this.enableDisableSaveButton();
    this.isGridDataDirty = true;
    if (element.spendID) {
      this.dirtySpendIds.push(element.spendID);
    }

  }

  //Change event of dropdown values
  onGridSellerInputChange($event, element: any) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
    this.enableDisableSaveButton();
    this.isGridDataDirty = true;
    element.isSellerActive = element.sellerListFiltered.filter(x => x.isActive == true && x.accountNumber == $event.accountNumber).length > 0;
    if (element.spendID) {
      this.dirtySpendIds.push(element.spendID);
    }

  }

  //Change event of dropdown values
  onGridGrowerInputChange($event, element: any) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
    this.enableDisableSaveButton();
    this.isGridDataDirty = true;
    element.isGrowerActive = element.growerListFiltered.filter(x => x.isActive == true && x.accountNumber == $event.accountNumber).length > 0;
    if (element.spendID) {
      this.dirtySpendIds.push(element.spendID);
    }

  }

  // Validate the values and allow only decimal value
  validateDecimal(event, element) {
    const currentValue = event.target.value;
    if (currentValue.includes('.') && event.key === '.') {
      event.preventDefault();
    } else if (event.key === ',' || event.key === ' ' || (event.key === '.' && currentValue.includes('.'))) {
      event.preventDefault();
    } else {
      const allowedRegex = RegExp('^[0-9.]+$');
      if (event.key.match(allowedRegex)) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { gpDataChange: true, labelNo: 'No, go back to Programs' });
        this.enableDisableSaveButton();
        this.isGridDataDirty = true;
        if (element.spendID) {
          this.dirtySpendIds.push(element.spendID);
        }
      } else {
        event.preventDefault();
      }
    }
  }

  // Validating details.
  validateSpendDeatil() {
    let isValidated = true;
    if (this.growerProgramData.data && this.growerProgramData.data.length > 0) {
      isValidated = true;
      this.growerProgramData.filteredData.forEach((x) => {
        x['lineErrors'] = new LineError();
        x = this.validateSpendDetailsDS(x);
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });
    }
    return isValidated;
  }

  validateSpendDetailsDS(productItem: any) {
    if (productItem.programMasterID != 0 && productItem.programMasterID != null) {
      if (productItem.programMasterID === null) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'programMasterID'
        );
        productItem.lineErrors.errors.push({
          id: 'programMasterID',
          error: 'Please select a Program',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem?.lineErrors?.errors.filter(
          (y) => y.id != 'programMasterID'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.budgetID === 0 || productItem.budgetID === null) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'budgetID'
        );
        productItem.lineErrors.errors.push({
          id: 'budgetID',
          error: 'Please select a budget',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'budgetID'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }

      if (productItem.retailerAccountNumber === 0 || productItem.retailerAccountNumber === null || productItem.retailerAccountNumber === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'retailerAccountNumber'
        );
        productItem.lineErrors.errors.push({
          id: 'retailerAccountNumber',
          error: 'Please select Retailer Account Number',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'retailerAccountNumber'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.productSegmentId === 0 || productItem.productSegmentId === undefined || productItem.productSegmentId === null) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'productSegmentId'
        );
        productItem.lineErrors.errors.push({
          id: 'productSegmentId',
          error: 'Please Select Sales Channel',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'productSegmentId'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
      if (productItem.lineErrors.errors.length > 0) {
        this.disableSaveButton = false;
        this.errorMsgs.push(productItem.lineErrors);
        this.getCommonErrors(this.errorMsgs);
      }
    }
    return productItem;
  }

  validateSpendDetailsFieldDS(productItem: any, fieldName: any, extraFieldName: any = null) {
    if (fieldName === 'programMasterId' || extraFieldName === 'programMasterId') {
      if (productItem.programMasterID === null || productItem.programMasterID === null) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'programMasterID'
        );
        productItem.lineErrors.errors.push({
          id: 'programMasterID',
          error: 'Please select a program name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'programMasterID'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });

        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'budgetId') {
      if (productItem.budgetID === 0 || productItem.budgetID === 0) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'budgetID'
        );
        productItem.lineErrors.errors.push({
          id: 'budgetID',
          error: 'Please select a budget name',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'budgetID'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'retailerAccountNumber') {
      if (productItem.retailerAccountNumber === 0 || productItem.retailerAccountNumber === 0) {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'retailerAccountNumber'
        );
        productItem.lineErrors.errors.push({
          id: 'retailerAccountNumber',
          error: 'Please enter a retailer account Number',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'retailerAccountNumber'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }
    if (fieldName === 'productSegmentId' || extraFieldName === 'productSegmentId') {
      if (productItem.productSegmentId === '' || productItem.productSegmentId === '') {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'productSegmentId'
        );
        productItem.lineErrors.errors.push({
          id: 'productSegmentId',
          error: 'Please select a sales channel',
        });
        productItem.lineErrors.itemId = productItem.id;
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(
          (y) => y.id != 'productSegmentId'
        );
        var index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.id;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }

    if (productItem.lineErrors.errors.length > 0) {
      if ((this.errorMsgs.filter((x) => x.itemId == productItem.id)).length > 0) {
        this.errorMsgs.map((x) => {
          if (x.itemId == productItem.id) {
            x['errors'] = productItem.lineErrors.errors;
            return x;
          }

        });
      }
      else {
        this.errorMsgs.push(productItem.lineErrors);
      }
      this.getCommonErrors(this.errorMsgs);
    }
    else {
      this.disableSaveButton = false;
    }
    return productItem;
  }

  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
      this.disableSaveButton = true;
    } else {
      this.showErrorBlock = false;
      this.disableSaveButton = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex((x) => x.itemId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.currentErrorRow = this.index + 1;
      $('#growerProgramView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset()
          .top;
        $('#growerProgramView').animate({ scrollTop: nextOffset }, 1000);
      }
    } else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.currentErrorRow = 1;
      $('#growerProgramView').scrollTop = 0;
      $('#growerProgramView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    this.enableDisableSaveButton();
    if (
      element &&
      element != null &&
      this.originalProductItemsDataSource.filteredData.length > 0 &&
      this.growerProgramData.data.length > 0
    ) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.data.filter(
          (x) => x.id === element.id
        )[0];
        oldLineValue.lineErrors = { itemId: oldLineValue.id, errors: [] };

        // get current object index
        const currentLineIndex = this.growerProgramData.data.findIndex(
          (x) => x.id === element.id
        );

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          const tempData = this.growerProgramData.data;
          const oldData = JSON.parse(JSON.stringify(oldLineValue));
          if (tempData[currentLineIndex].lineErrors.errors && tempData[currentLineIndex].lineErrors.errors.length > 0) {
            tempData[currentLineIndex].lineErrors.errors.forEach(e => {
              const error = JSON.parse(JSON.stringify(e));
              if (error.id == 'programMasterID') {
                tempData[currentLineIndex].programMasterID = oldData.programMasterID;
              }
              else if (error.id == 'budgetID') {
                tempData[currentLineIndex].budgetID = oldData.budgetID;
              }
              else if (error.id == 'retailerAccountNumber') {
                tempData[currentLineIndex].retailerAccountNumber = oldData.retailerAccountNumber;
              }
              else if (error.id == 'productSegmentId') {
                tempData[currentLineIndex].productSegmentId = oldData.productSegmentId;
              }
            });
          }
          tempData[currentLineIndex].lineErrors = oldData.lineErrors;
          tempData[currentLineIndex].lineError = oldData.lineError;
          this.growerProgramData = new MatTableDataSource(tempData);
          const index = this.errorMsgs.findIndex((x) => parseInt(x.itemId) == oldLineValue.id);
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.id);
          this.getCommonErrors(this.errorMsgs);
        }
      } else {
        // replace whole object

        // replace the new value with old value if it has error;
        this.growerProgramData.data.forEach(x => {
          if (x?.lineErrors?.errors && x?.lineErrors?.errors?.length > 0) {
            const tempData = JSON.parse(JSON.stringify(this.originalProductItemsDataSource.data.filter(o => o.id == x.id)[0]));
            x.lineErrors.errors.forEach(e => {
              const error = JSON.parse(JSON.stringify(e));
              if (error.id == 'programMasterID') {
                x.programMasterID = tempData.programMasterID;
              }
              else if (error.id == 'budgetID') {
                x.budgetID = tempData.budgetID;
              }
              else if (error.id == 'retailerAccountNumber') {
                x.retailerAccountNumber = tempData.retailerAccountNumber;
              }
              else if (error.id == 'productSegmentId') {
                x.productSegmentId = tempData.productSegmentId;
              }
            });
          }

          x.lineErrors = { itemId: x.id, errors: [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    } else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach((x) => {
          const errorDiv = $('#error_' + x.rowId?.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // For Checkbox
  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      //this.selectedCount = this.selectedCount + 1
      this.checkBoxCount = this.growerProgramData.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.growerProgramData.filteredData.filter(x => x.isSelected == false);
      this.selectedCount = this.checkBoxCount;
      if (this.checkBoxCount == this.growerProgramData.data.length) {
        this.isAllAccountsChecked = true;
      }
      else {
        this.isAllAccountsChecked = false;
      }
      this.manualOrderExtractionEnablecb = this.growerProgramData?.filteredData?.some(x => x.isSelected == true && this.isValidExtractStatus(x.status));
      this.showSubmit = this.growerProgramData.data.filter(x => (x.isSelected == true && x.level == null && x.status == null) || (x.isSelected == true && x.approvalStatus?.toLowerCase() == 'rejected')).length > 0;
      this.showApproveReject = this.growerProgramData.data.filter(x => x.isSelected == true && x.level != null && x.status != null).length > 0;
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      const checked = this.growerProgramData.filteredData.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
      }
      this.isAllAccountsChecked = false;
      this.selectedCount = this.selectedCount - 1;
      this.manualOrderExtractionEnablecb = this.growerProgramData?.filteredData?.some(x => x.isSelected == true && this.isValidExtractStatus(x.status));
      this.showSubmit = this.growerProgramData.data.filter(x => (x.isSelected == true && x.level == null && x.status == null) || (x.isSelected == true && x.approvalStatus?.toLowerCase() == 'rejected')).length > 0;

      this.showApproveReject = this.growerProgramData.data.filter(x => x.isSelected == true && x.level != null && x.status != null).length > 0;
    }
    this.showVoid = this.growerProgramData.data?.some(x => x.isSelected && !x.voided && x.spendID > 0) ?? false;
    this.showDelete = this.growerProgramData.data.filter(x => x.isSelected == true && x.isSpendDisabled !== true).length > 0;
    this.showApproveReject = this.growerProgramData.data.filter(x => x.isSelected == true && x.level != null && x.status != null && x.hasApprovalAccess).length > 0;
  }

  showTab(tabid: string) {
    if (tabid === 'void') {
      const hasUnsavedRecords = this.growerProgramData.data.some(x => x.isSelected && x.spendID == 0);
      if (hasUnsavedRecords) {
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: {
            title: 'Unsaved Records',
            message: 'Unsaved records will be deleted',
            labelYes: 'OK',
            labelNo: 'Cancel',
            dialogType: 'confirm',
          },
        });

        this.subscription.push(dialogRef.afterClosed().subscribe((result) => {
          if (result == true) {
            this.tabNode = tabid;
          }
        }));
        return;
      }
    }
    this.tabNode = tabid;
  }

  setAllFields(value: any) {
    if (value == true) {
      this.deleteSelectedSpendDetails();
    } else {
      this.editToolKit = true;
      this.showTabs = true;
    }
    this.tabNode = '';
  }

  approveRejectSubmit(value: any, requestType: any) {
    if (value == true) {
      this.approveRejectSpendDetails(requestType);
    } else {
      this.editToolKit = true;
      this.showTabs = true;
    }
    this.tabNode = '';
  }

  validateApproval(requestType: string) {
    if (requestType.toUpperCase() == 'SUBMIT') {
      let validData = this.growerProgramData.data.filter(x => (x.isSelected == true && x.level == null && x.status == null) || (x.isSelected == true && x.approvalStatus?.toLowerCase() == 'rejected'));
      if (validData && validData.filter(x => x.isSpendDisabled == true).length > 0) {
        this.toastrService.error(this.submitErrorMsg);
        return false;
      }
      if (validData && validData.filter(x => (x.estimatedQuantity == 0 || x.estimatedAmountToPay == 0)).length > 0) {
        this.toastrService.error('Estimated Quantity or Estimated Spend Quantity can not be 0.');
        return false;
      }

      if (validData && validData.filter(x => (x.programType.toUpperCase() == "GROWER") && (x.growerNumber == null || x.growerNumber == 0)).length > 0) {
        this.toastrService.error('Grower field is mandatory.');
        return false;
      }
    }
    else {
      let validData = this.growerProgramData.data.filter(x => x.isSelected == true && x.level != null && x.status != null && x.hasApprovalAccess);
      if (!validData || (validData && validData.length <= 0)) {
        this.toastrService.error(this.notAuthorizedErrorMsg);
        return false;
      }
    }
    return true;
  }


  saveManualExtractionData() {
    var saveList = [];
    this.growerProgramData.data
      .filter(x =>
        x.isSelected === true &&
        x.spendID != undefined &&
        x.spendID != 0 &&
        this.isValidExtractStatus(x.status))
      .forEach(data => {
        var filterItem = new GrowerProgramsData();
        filterItem.spendID = data.spendID;
        filterItem.status = data.status;
        saveList.push(filterItem);
      });

    if (saveList.length > 0) {
      this.openManualExtractionConfirmation(saveList);
    }
  }

  openManualExtractionConfirmation(saveList) {
    const title = 'Manual Order Extraction';
    const message = 'This will extract only those records which could not be processed because of Item Code or Pricing. Click OK to proceed. This will update the status to Manually Extracted.';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: {
        title: title,
        message: message,
        labelYes: 'OK',
        labelNo: 'Cancel',
        dialogType: 'confirm',
      },
    });

    this.subscription.push(dialogRef.afterClosed().subscribe((result) => {
      // If user selected Yes
      if (result == true) {
        this.updateManualExtractionData(saveList);
      }
    }));
  }



  updateManualExtractionData(data) {
    this.isGridDataDirty = false;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.growerProgramService
      .updateGrowerProgramManualExtraction(data)
      .subscribe(
        (result) => {
          if (result) {
            this.isCropYearChange = false;
            this.getLandingData(true, false, true, false, false);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.toastrService.success(
              'Spend Details Manually Extracted successfully.');
            if (result.base64) {
              this.growerProgramService.base64toFile(result.base64, result.mimeType, result.fileName);
            }
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error(
              'Spend Details not Manually Extracted.');
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }


  approveRejectSpendDetails(requestType: any) {
    if (this.validateSpendDeatil() && this.validateApproval(requestType)) {
      this.loaderService.setLoaderStatus(true);
      var saveList = [];
      let validSpendData = [];

      if (requestType.toUpperCase() == "SUBMIT") {
        validSpendData = this.growerProgramData.data.filter(x => (x.isSelected == true && x.level == null && x.status == null) || (x.isSelected == true && x.approvalStatus?.toLowerCase() == 'rejected'));
      }
      else {
        validSpendData = this.growerProgramData.data.filter(x => x.isSelected == true && x.level != null && x.status != null && x.hasApprovalAccess)
      }

      validSpendData.filter(x => x.programMasterID != 0 && x.programMasterID != null).forEach(data => {
        var filterItem = new GrowerProgramsData();

        filterItem.spendID = data.spendID;
        filterItem.retailerAccountNumber = data.retailerAccountNumber;
        filterItem.growerNumber = data.growerNumber;
        filterItem.programMasterID = data.programMasterID;
        filterItem.productLineId = data.productLineId;
        filterItem.productSegmentId = data.productSegmentId;
        filterItem.approvedAmountToPay = data.approvedAmountToPay;
        filterItem.budgetID = data.budgetID;
        filterItem.sellerAccountNumber = data.sellerAccountNumber;
        filterItem.marketingBrandId = data.marketingBrandId;
        filterItem.estimatedQuantity = data.estimatedQuantity;
        filterItem.estimatedAmountToPay = data.estimatedAmountToPay;
        filterItem.customerCreditAmount = data.customerCreditAmount;
        filterItem.status = data.status;
        filterItem.level = data.level;
        filterItem.approvalStatus = data.approvalStatus;
        saveList.push(filterItem);
      });

      if (saveList.length > 0) {
        this.subscription.push(this.growerProgramService.approveRejectSubmitSpendDetails(requestType.toUpperCase(), saveList).subscribe((result) => {
          this.selectedCount = 0;
          this.checkBoxCount = 0;
          this.isAllAccountsChecked = false;
          this.editToolKit = false;
          this.showTabs = false;
          this.isCropYearChange = false;
          this.getLandingData(true, false, true, false, false);

          if (result.status == true) {
            this.toastrService.success(result.message);
          } else {
            this.toastrService.error(
              result.message);
          }
          //this.loaderService.setLoaderStatus(false);
        },
          error => {
            LolLoggerService.error(error);
            this.selectedCount = 0;
            this.checkBoxCount = 0;
            this.isAllAccountsChecked = false;
            this.editToolKit = false;
            this.showTabs = false;
            this.isCropYearChange = false;
            this.getLandingData(true, false, true, false, false);
            //this.loaderService.setLoaderStatus(false);

            this.toastrService.error(
              'There is some error while ' + requestType);
          }
        ));
      }
      else {
        this.editToolKit = true;
        this.showTabs = true;
        this.loaderService.setLoaderStatus(false);
      }
    }
    else {
      this.editToolKit = true;
      this.showTabs = true;
    }
  }

  enableAllCheckBoxes(isChecked) {
    this.isAllAccountsChecked = isChecked;
    this.showVoid = false;
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.growerProgramData.filteredData.filter(y => !y.voided).forEach(x => {
        x.isSelected = true;
      });

      this.checkBoxCount = this.growerProgramData?.filteredData?.filter(x => x.isSelected == true).length;
      const selectedItem = this.growerProgramData?.filteredData?.filter(x => x.isSelected == true);
      if (selectedItem && selectedItem.length > 0) {
        this.editToolKit = true;
        this.manualOrderExtractionEnablecb = this.growerProgramData?.filteredData?.some(x => x.isSelected == true && this.isValidExtractStatus(x.status));
      }
      else {
        this.editToolKit = false;
      }
      this.selectedCount = this.checkBoxCount;

      this.showSubmit = this.growerProgramData.data.filter(x => (x.isSelected == true && x.level == null && x.status == null) || (x.isSelected == true && x.approvalStatus?.toLowerCase() == 'rejected')).length > 0;
    }
    else {
      this.showTabs = false;
      this.editToolKit = false;
      this.growerProgramData?.filteredData?.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
      this.manualOrderExtractionEnablecb = false;
      this.showSubmit = this.growerProgramData.data.filter(x => (x.isSelected == true && x.level == null && x.status == null) || (x.isSelected == true && x.approvalStatus?.toLowerCase() == 'rejected')).length > 0;
    }
    this.showVoid = false;
    this.showDelete = this.growerProgramData.data.filter(x => x.isSelected == true && x.isSpendDisabled !== true).length > 0;
    this.showApproveReject = this.growerProgramData.data.filter(x => x.isSelected == true && x.level != null && x.status != null && x.hasApprovalAccess).length > 0;
  }

  // Filter the Data
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName?.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber?.toString().indexOf(term) > -1
      || item.accountAddress1?.toLocaleLowerCase().indexOf(term) > -1
      || item.accountCity?.toLocaleLowerCase().indexOf(term) > -1
      || item.accountState?.toLocaleLowerCase().indexOf(term) > -1
      || item.accountZipCode?.toLocaleLowerCase().indexOf(term) > -1;
  }

  //Filter the Program and Budget
  programAndBudgetSearch(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value?.toLocaleLowerCase().indexOf(term) > -1
  }

  searchBudgetName(budgetId, budgetFilteredList) {
    const budget_data = budgetFilteredList.filter(o => {
      return o.id === budgetId
    });
    if (budget_data.length > 0) {
      return budget_data[0].value;
    } else {
      return '';
    }
  }

  searchRetailerName(accountNumber) {
    const retailer_data = this.retailerCombinedList.filter(o => {
      return o.accountNumber === accountNumber
    });
    if (retailer_data.length > 0) {
      return retailer_data[0].accountName;
    } else {
      return '';
    }
  }

  searchProgramName(programMasterId, filteredProgramList) {
    const program_data = filteredProgramList.filter(o => {
      return o.id === programMasterId
    });
    if (program_data.length > 0) {
      return program_data[0].value;
    } else {
      return '';
    }
  }
  searchProductSegment(productSegmentId) {
    const program_data = this.sales.filter(o => {
      return o.id === productSegmentId
    });
    if (program_data.length > 0) {
      return program_data[0].value;
    } else {
      return '';
    }
  }
  searchMarketingBrand(marketingBrandId) {
    const program_data = this.marketingList.filter(o => {
      return o.id === marketingBrandId
    });
    if (program_data.length > 0) {
      return program_data[0].value;
    } else {
      return '';
    }
  }
  searchProductLine(productLineId) {
    const program_data = this.productLineList.filter(o => {
      return o.id === productLineId
    });
    if (program_data.length > 0) {
      return program_data[0].value;
    } else {
      return '';
    }
  }
  searchSellerName(accountNumber) {
    const retailer_data = this.sellerCombinedList.filter(o => {
      return o.accountNumber === accountNumber
    });
    if (retailer_data.length > 0) {
      return retailer_data[0].accountName;
    } else {
      return '';
    }
  }
  searchGrowerName(accountNumber) {
    const retailer_data = this.growerCombinedList.filter(o => {
      return o.accountNumber === accountNumber
    });
    if (retailer_data.length > 0) {
      return retailer_data[0].accountName;
    } else {
      return '';
    }
  }
  searchRemainingBudget(value) {
    if (value < 0) {
      return '(' + String(value).split('-')[1] + ')';
    } else {
      return value;
    }
  }

  // Search Action
  filterSearchClick(filterValue) {
    if (!this.isFirstTimeload) {
      this.loaderService.setLoaderStatus(true);
      this.isCropYearChange = filterValue.cropYearList != this.prevCropYear ? true : false;
      this.filter = filterValue;
      this.prevCropYear = this.filter.cropYearList;
      this.getLandingData(true, false, true, false, this.isCropYearChange);
    } else {
      this.isFirstTimeload = false;
    }
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.loaderService.setLoaderStatus(true);
    this.isCropYearChange = event.cropYearList != this.prevCropYear ? true : false;
    this.filter = event;
    this.prevCropYear = this.filter.cropYearList;
    this.showOnlyActiveLines = true;
    this.getLandingData(true, false, true, false, true);
  }

  // Enable/Disable save button
  enableDisableSaveButton() {
    this.disableSaveButton = this.growerProgramData.data.some(({ lineErrors }) => lineErrors.errors.length > 0);
  }

  // For auto Saving Data.
  autoSaveData() {
    if (this.growerProgramData.data.filter(x => x.programMasterID != 0).length > 0 && (this.isGridDataDirty === true)) {
      const valid_grower_data = this.growerProgramData.data.filter(x => x.programMasterID != 0 && (x.budgetID !== null && x.retailerAccountNumber !== null));
      this.inCompleteSpends = this.growerProgramData.data.filter(x => x.programMasterID === 0 || !x.budgetID || !x.retailerAccountNumber);
      this.isAutosave = false;
      const validRecords = valid_grower_data
        .map((x) => {
          x['lineErrors'] = new LineError();
          x = this.validateSpendDetailsDS(x);
          return x;
        })
        .filter((x) => x.lineErrors.errors.length === 0);
      if (this.isGridDataDirty && this.inCompleteSpends.length === 0) {
        this.isAutosave = true;
        this.saveGrowerData(validRecords);
      } else if (this.isGridDataDirty) {
        this.isAutosave = true;
        this.saveGrowerData(validRecords);
      }

    }
  }

  // Main method to Save the data
  saveData() {
    this.disableSaveButton = true;
    this.loaderService.setLoaderStatus(true);
    if (this.validateSpendDeatil()) {
      var saveList = [];
      this.growerProgramData.data.filter(x => x.programMasterID != 0 && x.programMasterID != null && (this.dirtySpendIds.includes(x.spendID) || x.spendID == 0)).forEach(data => {
        var filterItem = new GrowerProgramsData();

        filterItem.spendID = data.spendID;
        filterItem.retailerAccountNumber = data.retailerAccountNumber;
        filterItem.growerNumber = data.growerNumber;
        filterItem.programMasterID = data.programMasterID;
        filterItem.productLineId = data.productLineId;
        filterItem.productSegmentId = data.productSegmentId;
        filterItem.approvedAmountToPay = data.approvedAmountToPay;
        filterItem.budgetID = data.budgetID;
        filterItem.sellerAccountNumber = data.sellerAccountNumber;
        filterItem.marketingBrandId = data.marketingBrandId;
        filterItem.estimatedQuantity = data.estimatedQuantity;
        filterItem.estimatedAmountToPay = data.estimatedAmountToPay;
        filterItem.customerCreditAmount = data.customerCreditAmount;
        saveList.push(filterItem);
      });

      if (this.growerProgramData.data.filter(x => x.programMasterID != 0).length > 0) {
        this.saveGrowerData(saveList);
        this.dirtySpendIds = [];
      }
    } else {
      this.loaderService.setLoaderStatus(false);
    }

  }


  clickOutsideReset() {
    if (this.tabNode === 'void') {
      this.voidReason = null;
    }
    this.tabNode = '';
  }
  // Save the Data
  saveGrowerData(data) {
    this.disableSaveButton = true;
    this.isGridDataDirty = false;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.growerProgramService
      .saveSpendDetails(data)
      .subscribe(
        (result) => {
          if (result) {
            this.isCropYearChange = false;
            //this.isMasterDataLoaded = false;
            this.getLandingData(true, false, true, false, false);
            this.selectedCount = 0;
            this.checkBoxCount = 0;
            this.isAllAccountsChecked = false;
            this.showTabs = false;
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

            this.toastrService.success(
              'Spend Details saved successfully.');
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error(
              'Spend Details not saved.');
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  updateVoidField(value: any) {
    if (value == true) {
      this.saveVoidSpendData(this.voidReason);
    } else {
      this.editToolKit = true;
      this.showTabs = true;
      this.voidReason = null;
    }
    this.tabNode = '';
  }

  saveVoidSpendData(voidReason) {
    this.loaderService.setLoaderStatus(true);
    voidReason = voidReason?.trim();
    var saveList = [];
    this.growerProgramData.data.filter(x => x.isSelected == true && (!x.voided) && (x.spendID != undefined && x.spendID != 0)).forEach(data => {
      var filterItem = new GrowerProgramsData();
      filterItem.spendID = data.spendID;
      filterItem.voidReason = voidReason;
      saveList.push(filterItem);
    });
    if (saveList.length > 0 && voidReason) {
      this.updateVoidData(saveList);
      this.dirtySpendIds = [];
    } else {
      this.loaderService.setLoaderStatus(false);
    }

  }

  updateVoidData(data) {
    this.isGridDataDirty = false;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.growerProgramService
      .updateGrowerProgramStatusVoid(data)
      .subscribe(
        (result) => {
          if (result) {
            this.voidReason = null;
            this.isCropYearChange = false;
            this.getLandingData(true, false, true, false, false);
            this.selectedCount = 0;
            this.checkBoxCount = 0;
            this.isAllAccountsChecked = false;
            this.showTabs = false;
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });

            this.toastrService.success(
              'Spend Details Voided successfully.');
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error(
              'Spend Details not Voided.');
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }


  //Deleting method.
  deleteSelectedSpendDetails() {
    /*if (this.growerProgramData.data.filter(x => x.isSelected == true && x.isSpendDisabled == true).length <= 0) {*/
      this.spendIds = this.growerProgramData.data.filter(x => x.isSelected == true && (x.spendID != undefined && x.spendID != 0 && x.isSpendDisabled !== true)).map((item) => item.spendID);
      if (this.spendIds.length > 0) {
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.growerProgramService
          .deleteSpendDetails(this.spendIds)
          .subscribe(
            (result) => {
              this.isCropYearChange = false;
              this.getLandingData(true, false, true, false, false);
              this.editToolKit = false;
              this.showTabs = false;
              if (result && result.status == false) {
                this.toastrService.error(result.message);
              } else {
                this.toastrService.success(
                  (result && result.message) ? result.message : 'Spend Details deleted successfully.');
              }
            },
            (error) => {
              LolLoggerService.error(error);
              this.loaderService.setLoaderStatus(false);

            this.toastrService.error(
              'Spend Details not deleted.');
          }
        ));
    }
    else {
      this.handleDeletion();
    }
    //}
    //else {
    //  this.toastrService.error(this.submitErrorMsg);
    //  this.editToolKit = true;
    //  this.showTabs = true;
    //}
  }

  handleDeletion() {
    this.growerProgramData.data.filter(x => x.isSelected == true && x.lineErrors.errors.length > 0).forEach(x => {
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === x.id;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    });
    this.growerProgramData.data = this.growerProgramData.data.filter(x => x.isSelected != true);
    this.enableCheckBoxSingle(true);
    this.selectedCount = 0;
    this.checkBoxCount = 0;
    this.isAllAccountsChecked = false;
    this.editToolKit = false;
  }

  // Reset the Grid
  resetGrid() {
    const title = 'Reset Filters';
    const message = 'Do you want to reset the record filters?';
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: {
        title: title,
        message: message,
        labelYes: 'Yes',
        labelNo: 'No',
        dialogType: 'confirm',
      },
    });

    this.subscription.push(dialogRef.afterClosed().subscribe((result) => {
      // If user selected Yes
      if (result == true) {
        this.loaderService.setLoaderStatus(true);
        this.isCropYearChange = this.filter.cropYearList != this.defaultYear ? true : false;
        let cropyear = this.filter.cropYearList == '' ? null : this.filter.cropYearList;
        this.revertAllChanges();
        this._filter.clearAllFilterWithoutEmit();
        this.showOnlyActiveLines = true;
        this.setDefaultFilter();
        this.setCropYearFilter(cropyear);
        this.filter.cropYearList = this.defaultYear;
        this.filterOptionsData = [];
        this.setFilterAndGridColumn(true, this.defaultYear);
        if (this.isCropYearChange && this.prevCropYear != this.defaultYear) {
          this.toastrService.warning(this.resetFilterMsg);
        }
        if (this.isCropYearChange) {
          this.prevCropYear = this.filter.cropYearList;
        }


        this.getLandingData(false, true, true, false, false);
        this.selectedCount = 0;
        this.checkBoxCount = 0;
        this.isAllAccountsChecked = false;
        this.disableSaveButton = true;
        this.isGridDataDirty = false;
        this.dirtySpendIds = [];
        this.isCropYearChange = false;
      }
    }));
  }

  // Import data
  importGrowerProgramPopup() {
    var dialogRef = this.matDialog.open(GrowerProgramImportComponent, {
      disableClose: true,
      width: '90vw',
      maxWidth: '90vw',
      data: { masterData: this.masterData, landingData: this.landingData, filterData: this.filter }
    });
    dialogRef.afterClosed().subscribe(result => {
      //If user selected Yes
      if (result) {
        this.saveGrowerData(result);
      }
    });
  }

  // Export Upload Template
  exportDataTemplate(isUploadTemplate: boolean) {
    this.loaderService.setLoaderStatus(true);
    let excelData: any = {};
    this.masterData.filters = { ...this.filter, ShowActiveLines: this.showOnlyActiveLines };
    this.masterData.isUploadTemplate = isUploadTemplate;

    if (!isUploadTemplate) {
      excelData.filters = this.masterData.filters;
      excelData.isUploadTemplate = isUploadTemplate;
    } else if (isUploadTemplate) {
      excelData = this.masterData;
    }



    this.subscription.push(this.growerProgramService
      .exportSpendDetailsExcelFile(excelData)
      .subscribe(
        (result) => {
          if (result) {

            this.growerProgramService.base64toFile(result.base64, result.mimeType, result.fileName);
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error(
              'There is some issue while downloading the template.');
          }
          this.masterData.filters = this.filter;
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  // Open Slider Model for Grower Search
  openGrowerSliderModel(index, retailerNumber) {
    this.currentIndex = index;
    if ((this.growerAccountNo && this.growerAccountNo != 0) || retailerNumber != 0) {
      this.sliderModelService.initializeComponentVal(retailerNumber);
      this.sliderModelService.toAccountNumber.next(retailerNumber);
      this.sliderModelService.growerSearchType.next('GP');
      this.sliderModelService.activeSlider('growerSearchSlider');
    }
    else {
      this.toastrService.warning('Select an Retailer Account before adding a Grower.');
    }
  }

  // Open Slider Model for Budget Search
  openProgramBudgetSliderModel(element, index) {
    const budgetShowAllList = this.validBudgetList.filter(x => x.programActive == true && x.budgetActive == true);
    if ((element.budgetFilteredList && budgetShowAllList.length > 0)) {
      this.sliderModelService.growerProgramBudgetSliders(budgetShowAllList);
      this.sliderModelService.activeSlider('growerProgramBudgetSlider');
      this.currentElement = element;
      this.currentIndex = index;
    }
    else {
      this.toastrService.warning('No Budget Data.');
    }

  }

  // Open Slider Model for Retailer Search
  openRetailerSearchSliderModel(index, element) {
    const retailerShowAllList = this.getValidRetailersForShowAll(element);
    if (retailerShowAllList !== null && retailerShowAllList.length > 0) {
      this.currentElement = element;
      this.sliderModelService.activeSlider('retailerSearchSlider');
      this.sliderModelService.initializeRetailerDataValue(retailerShowAllList);
      this.sliderModelService.setRetailerSearchIndexValue(index);
      const sub = this.sliderModelService.selectedRetailerAccount.subscribe(selected_retailer_account_number => {
        if (selected_retailer_account_number && selected_retailer_account_number > 0) {
          const event = {
            accountNumber: selected_retailer_account_number
          };
          const retailer_index = this.sliderModelService.getRetailerSearchIndexValue();
          this.onGridInputChangeRetailer(event, this.currentElement, this.retailerFieldName, retailer_index);
        }
      });
      this.subscription.push(sub);
    } else {
      this.toastrService.warning('No Retailer Data.');
    }
  }

  // Open Slider Model for Program Name Search
  openProgramNameSliderModel(element, index) {
    const programShowAllList = this.validProgramList.filter(x => x.programActive == true);
    if ((programShowAllList != null && programShowAllList.length > 0)) {
      this.sliderModelService.growerProgramNameSliders(programShowAllList);
      this.sliderModelService.activeSlider('growerProgramNameSlider');
      this.currentElement = element;
      this.currentIndex = index;
    }
    else {
      this.toastrService.warning('No Program Data.');
    }
  }

  // Open Slider Model for Comment
  openCommentSliderModel(element, index) {
    const commentData = {
      spendID: element.spendID,
      programName: element.programName,
      budgetName: element.budgetName,
      isSpendDisabled: element.isSpendDisabled
    }
    this.sliderModelService.growerProgramCommentSliders(commentData);
    this.sliderModelService.activeSlider('growerProgramCommentSlider');
    this.currentElement = element;
    this.currentIndex = index;
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
    window.localStorage.setItem('idleSeconds', '0');
  }

  resetIdleAndTimeOut() {
    this.idle.watch();
    this.timedOut = false;
    this.showTimer = false;
  }

  // Method will be used to Add Idle events.
  AddIdleAutoCancelEvents() {
    this.subscription.push(this.idle.onIdleEnd.subscribe(() => {
      this.resetIdleAndTimeOut();
    }));

    this.subscription.push(this.idle.onTimeout.subscribe(() => {
      this.timedOut = true;
      this.showTimer = false;
      this.autoSaveData();
    }));

    this.subscription.push(this.idle.onTimeoutWarning.subscribe((countdown) => {
      if (this.isGridDataDirty) {
        this.showTimer = true;
        this.autoCancelCounter = countdown;
      } else {
        this.resetIdleAndTimeOut();
      }

    }));

    this.resetIdleAndTimeOut();
  }

  updateReportingSubscriptionStatus() {
    this.reportingSubscriptionStatus = !this.reportingSubscriptionStatus;
    this.subscription.push(this.growerProgramService
      .saveGPSubscriptionStatus(this.reportingSubscriptionStatus)
      .subscribe(
        (result) => {
          if (result) {
            this.reportingSubscriptionStatus = this.reportingSubscriptionStatus;
          } else {
            this.reportingSubscriptionStatus = !this.reportingSubscriptionStatus;
          }
        },
        (error) => LolLoggerService.error(error)
      ));
  }

  getCellStyle(approvalStatus: string, status: string): any {
    let cellStyle = {};
    const errorStatusList = [
      'credit request failed',
      'error - budget user invalid',
      'error - bu & retailer combination invalid'
    ];

    status = (status == null || status == undefined) ? '' : status;
    if (this.isValidExtractStatus(status)) {
      // cellStyle = { 'background-color': 'rgb(181, 188, 192)' }; // grey
      // cellStyle = { 'background-color': '#F8E1E5' }; // pink
      // cellStyle = { 'background-color': '#EEE6FF' } // lavender
      cellStyle = { 'background-color': '#D6EAF8' } // light blue 
      return cellStyle;

    }

    if (approvalStatus !== null && approvalStatus !== undefined) {
      const approveRejectStatus = approvalStatus.toLowerCase();

      if (approveRejectStatus === 'rejected' || errorStatusList.includes(status.toLowerCase())) {
        cellStyle = { 'background-color': '#f5c6cb' } // red
      }
      else if (approveRejectStatus === 'pending') {
        cellStyle = { 'background-color': '#ffeeba' }; // yellow
      }
      else if (approveRejectStatus === 'approved') {
        cellStyle = { 'background-color': '#c3e6cb' }; // green
      }
    }
    else {
      if (errorStatusList.includes(status.toLowerCase())) {
        cellStyle = { 'background-color': '#f5c6cb' } // red
      }
    }


    return cellStyle;
  }

  // Toggle method for All items and Special items
  toggleShowActiveOnly() {
    this.loaderService.setLoaderStatus(true);
    this.showOnlyActiveLines = !this.showOnlyActiveLines;
    this.getLandingData(true, false, true, false, this.isCropYearChange);
  }

  jDEDetails(element: any) {
    const data = { title: 'Credit Details', jdeOrderNumber: element.jdeorderNumber, jdeOrderType: element.jdeorderType, dialogType: 'gpJdeDetails' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: false,
      width: '350px',
      data: data
    });
  }

}
